import { z } from 'zod';
export const ZObjectIdString = z.string().length(24);
export const ZIsoDateTime = z.string().refine((s) => z.string().datetime({ offset: true }).safeParse(s).success ||
    z.string().datetime({ local: true }).safeParse(s).success, { message: "Invalid datetime" });
export const ZDateish = z.union([z.date(), ZIsoDateTime]);
// ------------------------------SCHEMAS------------------------------//
// src/schemas/project.base.ts
export const ZTrueObjectId = z.any();
export const ZProjectNo = z.number().refine((val) => {
    const len = val.toString().length;
    return len === 6 || len === 8;
}, {
    message: "projectId must be a 6- or 8-digit number",
});
export const ZCoordinate = z
    .array(z.number())
    .max(3)
    .min(2)
    .refine((arr) => !((arr.length === 2 && arr[0] === 0 && arr[1] === 0) ||
    (arr.length === 3 && arr[0] === 0 && arr[1] === 0 && arr[2] === 0)), { message: "Coordinate [0,0] or [0,0,0] is not valid" });
/**
 * OPTIONAL — if you want a small wrapper to embed into ZRoom:
 *
 * export const ZRoomValidation = z.object({
 *   standardRoom: ZRoomValidationStandardRoom.optional(),
 * });
 * export type RoomValidation = z.infer<typeof ZRoomValidation>;
 *
 * Then inside your existing ZRoom you can add:
 *   validation: ZRoomValidation.optional()
 */
export const ZDeviceCategoryEnum = z.enum([
    "CHILLER_DEVICE",
    "DEFAULT_DEVICE",
    "DOOR",
    "DOWN_LIGHT_DEVICE",
    "FIRE_SUPPRESSION_DEVICE",
    "FURNITURE",
    "LIGHT_DEVICE_CIRCULAR",
    "LIGHT_DEVICE",
    "RETURN_AIR_DEVICE",
    "SENSOR_DEVICE",
    "SUPPLY_AIR_DEVICE",
    "WINDOW",
]);
export const ZDirection = z.array(z.number());
// Bruk denne når du forventer 2D (men uten tuples, pga OpenAPI)
export const ZCoordinate2D = z
    .array(z.number())
    .min(2)
    .max(2)
    .refine(arr => !(arr[0] === 0 && arr[1] === 0), {
    message: 'Koordinat [0,0] er ikke gyldig',
});
export const ZBoundingBox2D = z.array(ZCoordinate2D).min(4); // typisk 4 eller 5 (lukket ring)
export const ZPolygon2D = z.array(ZCoordinate2D).min(4); // typisk lukket ring
export const ZBoundingBox = z.array(ZCoordinate);
export const ZDIsciplineEnum = z.enum([
    "VENTILATION",
    "ELECTRICAL",
    "SPRINKLER",
    "ARCHITECTURE",
    "UNKNOWN",
]);
export const ZMultiplacerModuleKey = z.enum(["CEILING", "RFP", "EXPLORE", "ROOM_NUMBERING"]);
export const ACTIVE_MODULE_KEYS = ZMultiplacerModuleKey.options;
export const ZEmailLowercase = z
    .string()
    .email()
    .refine((s) => s === s.toLowerCase(), "email must be lowercase");
export const ZEmailInput = z.string().email().transform((s) => s.trim().toLowerCase());
